<template>
  <div class="userDropdown">
    <a-dropdown>
      <div class="avatar">
        <a-avatar>
          <template #icon>
            <UserOutlined />
          </template>
        </a-avatar>
        <span class="username"> {{ account }} </span>
      </div>
      <template #overlay>
        <a-menu>
          <a-menu-item key="updatePassword" @click="showChangePasswordModal">
            <a href="javascript:;">修改密码</a>
          </a-menu-item>
          <a-menu-item key="logout" @click="logout">
            <a href="javascript:;">退出登录</a>
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>

    <ChangePasswordModal v-model:visible="changePasswordModalVisible" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { UserOutlined } from '@ant-design/icons-vue'
import { useUserStore } from '@/stores/user'
import { message } from 'ant-design-vue'
import ChangePasswordModal from '@/components/changePasswordModal/index.vue'

defineOptions({
  name: 'userDropdown',
})

const userStore = useUserStore()
const { account } = userStore.getUserInfo()

const changePasswordModalVisible = ref(false)

const logout = async () => {
  console.log('退出登录')
  await userStore.logout(true)
  message.success('退出成功')
}

const showChangePasswordModal = () => {
  changePasswordModalVisible.value = true
}
</script>

<style scoped lang="less">
.userDropdown {
  cursor: pointer;
  display: flex;
  align-items: center;

  .avatar {
    display: inline-block;
  }
  .username {
    display: inline-block;
    margin-left: 10px;
    font-size: 16px;
    font-weight: 600;
  }
}
</style>
